import { render, staticRenderFns } from "./BTableUsersHistory.vue?vue&type=template&id=1116484f&"
import script from "./BTableUsersHistory.vue?vue&type=script&lang=js&"
export * from "./BTableUsersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports